import React from 'react';
import SVG from '@atlaskit/icon/svg';
import type { SVGProps } from '@atlaskit/icon/types';

export const TransitionHelpPanelIcon = (props: SVGProps) => {
	const { primaryColor, size, label } = props;
	return (
		<SVG primaryColor={primaryColor} size={size} label={label}>
			<path
				fill="currentColor"
				d="M8.1926 18.5576c-.27 0-.55-.11-.76-.32-.42-.42-.42-1.1 0-1.52l4.71-4.71-4.75-4.74c-.42-.42-.42-1.1 0-1.52.42-.42 1.1-.42 1.52 0l5.51 5.51c.2.2.32.48.32.76s-.11.56-.32.76l-5.47 5.47c-.21.21-.49.32-.76.32v-.01Z"
			/>
			<path
				fill="currentColor"
				d="M13.9524 18.5576c-.28 0-.55-.11-.76-.32-.42-.42-.42-1.1 0-1.52l4.71-4.71-4.75-4.74c-.42-.42-.42-1.1 0-1.52.42-.42 1.1-.42 1.52 0l5.51 5.51c.42.42.42 1.1 0 1.52l-5.47 5.47c-.21.21-.48.32-.76.32v-.01ZM5.8324 14.3275c1.2869 0 2.33-1.0432 2.33-2.33 0-1.2868-1.0431-2.33-2.33-2.33-1.2868 0-2.33 1.0432-2.33 2.33 0 1.2868 1.0432 2.33 2.33 2.33Z"
			/>
		</SVG>
	);
};
